const TONES = {
  brown: "bg-brown-dark text-cream",
  teal: "bg-teal-dark text-cream",
  light: "bg-cream/10 border border-cream/30 text-cream backdrop-blur-sm",
};

export const SectionTag = ({ icon: Icon, label, tone = "brown" }) => (
  <div
    className={`inline-flex items-center gap-2 px-4 py-2 mb-6 ${TONES[tone]}`}
    data-testid={`section-tag-${label.toLowerCase().replace(/\s+/g, "-")}`}
  >
    {Icon && <Icon size={13} />}
    <span className="font-mono text-[11px] uppercase tracking-[0.22em]">{label}</span>
  </div>
);
